module.exports = __webpack_public_path__ + "img/issue.f286ac6b.png";